import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import { ReactComponent as VolumeIcon } from "assets/images/iconsV2/volume-cubic-meter.svg";
import { ReactComponent as WeightIcon } from "assets/images/iconsV2/weight.svg";
import { calculateTotals } from "../helpers";

export default function TotalCalculations() {
  const { watch } = useFormContext();
  const packingListItems = watch("packing_list");
  const { totalCbm, totalWeight, weightUnit } = calculateTotals(packingListItems || []);

  return (
    <div
      className="py-md px-lg bg-quaternary radius-xs gap-sm"
      style={{ display: "grid", gridTemplateColumns: "min-content 1fr min-content" }}
    >
      <VolumeIcon />
      <div className="text-secondary font-regular" style={{ minWidth: "80px" }}>
        <FormattedMessage id="general.totalCBM" defaultMessage="Total CBM" />
      </div>
      <div className="font-medium text-secondary-v2 text-right text-nowrap">{totalCbm.toFixed(2)} m3</div>

      <WeightIcon />
      <div className="text-secondary font-regular" style={{ minWidth: "90px" }}>
        <FormattedMessage id="general.totalWeight" defaultMessage="Total Weight" />
      </div>
      <div className="font-medium text-secondary-v2 text-right text-nowrap">
        {totalWeight.toFixed(2)} {weightUnit}
      </div>
    </div>
  );
}
